import { useApolloClient } from '@apollo/client';
import { useFocusEffect, useNavigation, useRoute } from '@react-navigation/native';
import { useCallback, useState } from 'react';

import { InputArtifactResult } from '@oui/lib/src/types/actionEnvelopes';

import { Button } from '../components/Button';
import { ARTIFACT_HANDLERS } from '../components/ChatInputArtifact';
import { RoundedSection } from '../components/RoundedSection';
import { Text } from '../components/Text';
import { startArtifactRequest, useArtifactResult } from '../hooks/useArtifactResult';
import { StackScreenProps } from '../types/navigation';

export function TestArtifactResult() {
  const route = useRoute<StackScreenProps<'TestArtifactResult'>['route']>();
  const navigation = useNavigation<StackScreenProps<'TestArtifactResult'>['navigation']>();
  // @ts-ignore
  const [attempt, setAttempt] = useState(0);
  const [result, setResult] = useState<InputArtifactResult>();
  const apollo = useApolloClient();

  useFocusEffect(
    useCallback(() => {
      return () => setResult(undefined);
    }, []),
  );

  useArtifactResult((result) => {
    setResult(result);
  });

  return (
    <RoundedSection color="#ebf1ed" secondaryColor="white" title="Test" testID="TestArtifactResult">
      {result ? (
        <Text
          text={`Complete? ${result.complete}`}
          testID={
            result.complete
              ? 'TestArtifactResult_resultComplete'
              : 'TestArtifactResult_resultNotComplete'
          }
        />
      ) : null}
      {result?.ID ? <Text text={result.ID} testID={'TestArtifactResult_resultID'} /> : null}
      <Button
        text="Start artifact"
        testID="TestArtifactResult_startButton"
        onPress={async () => {
          let started = false;
          const ensureStartArtifactRequest: typeof startArtifactRequest = (name) => {
            started = true;
            startArtifactRequest(name);
          };

          if (ARTIFACT_HANDLERS[route.params.artifactName]) {
            await ARTIFACT_HANDLERS[route.params.artifactName]!({
              startArtifactRequest: ensureStartArtifactRequest,
              apollo,
              navigate: navigation.navigate,
              params: route.params.params ? JSON.parse(route.params.params) : undefined,
            });

            if (!started) {
              throw new Error(
                'Forgot to call startArtifactRequest in registerChatInputArtifactHandler callback',
              );
            }
          } else {
            startArtifactRequest(route.params.artifactName);
            navigation.navigate(
              // @ts-ignore
              route.params.artifactName === 'SleepDiary'
                ? 'SetupSleepDiary'
                : route.params.artifactName,
              route.params.params ? JSON.parse(route.params.params) : undefined,
            );
          }
        }}
      />
    </RoundedSection>
  );
}
